/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import I18n from 'components/Translate/I18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { featuresActions, featuresConstans } from '../../modules/features/actions';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import FeaturesRow from 'views/Features/FeaturesRow';
import SuccessInfo from 'components/Info/SuccessInfo';
import AlertInfo from 'components/Info/AlertInfo';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { ServicesMvneType } from '../../modules/lib/hooks/useOperatorType';
import { ActiveFeatureItemSdgBme } from './component/opl/Active/ActiveFeatureItemSdgBme';
import { ComponentParamsDialog } from './component/ComponentParamsDialog';
import { notificationConstants } from '../../modules/notifications/notifications';
import { AwaitingFeatureItemSdgBme } from './component/opl/Check/AwaitingFeatureItemSdgBme';

class FeaturesAwaitingList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            simCard: this.props.simCard,
            activeList: null,
            deleteParams: null,
            alert: null,
            definitionComponent: null,
            componentParamsDialogOpen: false,
            verbType: null,
            componentParamsDialogTitle: null,
            alreadySelectedValues: null,
            forceStart: null,
        };
        this.loader = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount() {
        this.initial();
    }

    initial = () => {
        this.loader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_pending_activations')),
            'none',
            [{ name: 'simCard', value: this.state.simCard.id }],
            [{ name: 'createdAt', value: 'asc' }],
            (data) => {
                this.setState({
                    activeList: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    deleteFeatureConfirm = (params) => {
        this.setState({
            deleteParams: params,
            alert: (
                <AlertInfo
                    onConfirm={this.deleteCallApi}
                    onCancel={this.cancelDelete}
                    confirmBtnText={'simcard:f.remove_component'}
                    cancelBtnText={'general:common.cancel'}
                    content="simcard:f.confirm_remove_component"
                />
            ),
        });
    };

    forceStartComponent = (params) => {
        this.setState({
            forceStart: params,
            alert: (
                <AlertInfo
                    onConfirm={this.forceStartAction}
                    onCancel={this.cancelDelete}
                    confirmBtnText={'simcard:f.force_start_action'}
                    cancelBtnText={'general:common.cancel'}
                    content="simcard:f.confirm_force_start_action"
                />
            ),
        });
    };

    cancelDelete = () => {
        this.setState({ alert: null, deleteParams: null });
    };

    deleteCallApi = (call) => {
        const params = this.state.deleteParams;

        const payload = {
            componentName: this.state.deleteParams.componentName,
            simCardId: this.state.simCard.id,
            status: this.state.deleteParams.status,
            params: JSON.stringify({ pendingId: this.state.deleteParams.pendingId }),
        };

        if (params !== null) {
            const { dispatch } = this.props;
            dispatch(
                featuresActions.post(
                    FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_on_services')),
                    payload,
                    featuresConstans.FEATURES_POST,
                    () => {
                        this.setState(
                            {
                                activeList: {},
                                alert: (
                                    <SuccessInfo
                                        onConfirm={this.cancelDelete}
                                        confirmBtnText="general:common.ok"
                                        content="simcard:f.remove_component_request_send"
                                    />
                                ),
                            },
                            this.initial
                        );
                    }
                )
            );
        } else {
            this.cancelDelete();
        }
    };

    forceStartAction = (call) => {
        const params = this.state.forceStart;

        const payload = {
            componentName: params.componentName,
            simCardId: this.state.simCard.id,
            status: params.status,
            params: JSON.stringify({ pendingId: params.pendingId }),
        };

        if (params !== null) {
            const { dispatch } = this.props;
            dispatch(
                featuresActions.post(
                    FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_on_services')),
                    payload,
                    featuresConstans.FEATURES_POST,
                    () => {
                        this.setState(
                            {
                                activeList: {},
                                alert: (
                                    <SuccessInfo
                                        onConfirm={this.cancelDelete}
                                        confirmBtnText="general:common.ok"
                                        content="simcard:f.force_component_request_send"
                                    />
                                ),
                            },
                            this.initial
                        );
                    }
                )
            );
        } else {
            this.cancelDelete();
        }
    };

    confirmCallback = (componentParams) => {
        const { dispatch } = this.props;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_on_services')),
            'post_active_component_with_params',
            componentParams,
            (data) => {
                this.setState({ activeList: null }, () => {
                    dispatch({
                        type: notificationConstants.SUCCESS,
                        message: 'simcard:f.activate_component_request_send',
                    });
                    this.closeComponentParamsDialog();
                    this.initial();
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    openComponentParamsDialog = (verbType, definitionComponent, componentParamsDialogTitle, alreadySelectedValues) => {
        this.setState({
            definitionComponent: definitionComponent,
            componentParamsDialogOpen: true,
            verbType: verbType,
            componentParamsDialogTitle: componentParamsDialogTitle,
            alreadySelectedValues: alreadySelectedValues,
        });
    };

    closeComponentParamsDialog = () => {
        this.setState({
            definitionComponent: null,
            componentParamsDialogOpen: false,
            verbType: null,
            componentParamsDialogTitle: null,
        });
    };

    render() {
        const {
            activeList,
            alert,
            componentParamsDialogOpen,
            definitionComponent,
            verbType,
            simCard,
            componentParamsDialogTitle,
            alreadySelectedValues,
        } = this.state;
        return (
            <React.Fragment>
                {activeList && activeList['hydra:member'] && (
                    <>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">
                                        <I18n trans="simcard:f.id" />
                                    </TableCell>
                                    <TableCell align="left">
                                        <I18n trans="simcard:f.component_name" />
                                    </TableCell>
                                    <TableCell align="left">
                                        <I18n trans="simcard:list.createdAt" />
                                    </TableCell>
                                    <TableCell align="right">
                                        <I18n trans="simcard:f.action" />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {activeList['hydra:member'].map((row) => {
                                    return (
                                        <AwaitingFeatureItemSdgBme
                                            key={'services_' + row.id}
                                            simCardService={row}
                                            forceStartComponent={this.forceStartComponent}
                                            openComponentParamsDialog={this.deleteFeatureConfirm}
                                        />
                                    );
                                })}
                            </TableBody>
                        </Table>
                        {alert}
                        {definitionComponent && verbType && (
                            <ComponentParamsDialog
                                open={componentParamsDialogOpen}
                                definitionComponent={definitionComponent}
                                isActivationMode={false}
                                closeCallback={this.closeComponentParamsDialog}
                                confirmCallback={this.confirmCallback}
                                simCardId={simCard.id}
                                simCard={simCard}
                                verbType={verbType}
                                title={componentParamsDialogTitle}
                                alreadySelectedValues={alreadySelectedValues}
                            />
                        )}
                    </>
                )}
            </React.Fragment>
        );
    }
}

FeaturesAwaitingList.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return { ...state };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(FeaturesAwaitingList);
export default Enhance;
